import React from 'react';
import {useSearchParams} from 'react-router-dom';
import {RugbyRulesPage} from "@/pages/RugbyRulesPage.jsx";
import {FootballRulesPage} from "@/pages/FootballRulesPage.jsx";

export const RulesPage = () => {
    const [searchParams] = useSearchParams();
    const type = searchParams.get('type');

    if (type === 'RUGBY') {
        return <RugbyRulesPage/>;
    }

    // Par défaut, on renvoie vers le Foot
    return <FootballRulesPage/>;
};